import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomersService } from '../rest_services/customers.service';
import { DashboardService } from '../rest_services/dashboard.service';
import { VisitService } from '../rest_services/visit.service';
import { VisitsService } from '../rest_services/visits.service';
import { visite } from './visite';
import { MsSectorService } from '../rest_services/ms-sector.service';
declare var NotificationFx:any;
declare var Snap:any; 

interface Visite {
  AcheteurClient: String;
  Secteur: String;
  Datevisite: Date;
  Adressepostale: String;
  Ville: String;
}
@Component({
  selector: 'app-deplacement',
  templateUrl: './deplacement.component.html',
  styleUrls: ['./deplacement.component.css']
})
export class DeplacementComponent implements OnInit {

  Visite: any[] = visite;
  DataTable:any;
  planned:string="";
  inProgress:string="";
  done:string="";
  reported:string="";
  canceled:string="";
  terminatedVisitForm:FormGroup;
  token : any = '';
  planifierForm: FormGroup;

  constructor(private fb:FormBuilder,
    private customersService:CustomersService,
    private deplacementServiceservice:VisitsService,
    private msSector : MsSectorService,
    private visitService:VisitService, private dashboardServiceservice:DashboardService,
    private visitServiceservice:VisitsService,
    private cdr: ChangeDetectorRef) { 
    this.Visit();
    this.Actions();
    this.terminatedVisitForm = this.fb.group({
      'contact_fullname': ['', Validators.required],
      'contact_function' : [''],
      'contact_phone' : ['', [Validators.pattern("^((\\+91-?)|0)?[0-9+]{10,13}$")]],
      'contact_email' : ['', [Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
    this.planifierForm = this.fb.group({
      'planned_date': ['', [Validators.required, this.validateDate]],
    })
  }
  validateDate(control: any) {
    const selectedDate = new Date(control.value);
    const currentDate = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
  
    if (selectedDate < currentDate) {
      return { 'invalidDate': true };
    }

    return null;
  }
  loading_indicator:boolean=true;
  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.Deplacement();
    this.TodayPlanning();
    var glob =this;
    $('body').on('click', ".upload__img-close", function (e:any) {
      var file = $(this).parent().data("file");
      for (var i = 0; i < glob.imgArray.length; i++) {
        if (glob.imgArray[i].name === file) {
          glob.imgArray.splice(i, 1);
          glob.picturesVisit.splice(i, 1);
          break;
        }
      }
      $(this).parent().parent().remove();
    });
    //SHOW NOTIFICATION TO COMMERCIAL TO CREATE NEW VISITS
    var svgshape = document.getElementById( 'notification-corner-expand-shape' )as HTMLElement,
      s = Snap( svgshape?.querySelector( 'svg' ) ),
      path = s.select( 'path' ),
      pathConfig = {
          from : path?.attr( 'd' ),
          to : svgshape?.getAttribute( 'data-path-to' )
      }
      NotificationFx.prototype.options = {
        wrapper : document.body,
        message : 'yo!',
        layout : 'growl',
        effect : 'slide',
        type : 'error',
        ttl : 180000, //TIMEOUT CLOSE NOTIFICATIONS - BY ROU
        // callbacks
        onClose : function() { return false; },
        onOpen : function() { return false; }
      }
  }

  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];
  picturesVisitUpdate:any[]=[];
  addPic(event:any,modal:any){
    if(modal =="terminate"){
      this.imgWrap = $('.upload__inputfile').closest('.upload__box').find('.upload__img-wrap');
    }else {
      this.imgWrap = $('.upload__inputfile_update').closest('.upload__box').find('.upload__img-wrap');
    }
    
    var maxLength:any  = $(this).attr('data-max_length');
    
    var files:any = event.target.files;
    var filesArr:any = Array.prototype.slice.call(files);
    var iterator:any = 0;
    var glob=this;
    filesArr.forEach(function (f:any, index:any) {
      
      if (!f.type.match('image.*')) {
        return;
      }

      if (glob.imgArray.length > maxLength) {
        return false
      } else {
        var len = 0;
        for (var i = 0; i < glob.imgArray.length; i++) {
          if (glob.imgArray[i] !== undefined) {
            len++;
          }
        }
        if (len > maxLength) {
          return false;
        } else {
          glob.imgArray.push(f);

          var reader = new FileReader();
          reader.onload = function (e:any) {
            
            if(modal =="terminate"){
              var html = "<div class='upload__img-box'><div style='background-image: url(" + e.target.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + f.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";
              glob.imgWrap.append(html);
              glob.picturesVisit.push(e.target.result);
            }else {
              var html = "<div class='upload__img-box'><div style='background-image: url(" + e.target.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + f.name + "' class='img-bg'><div class='upload__img-close' id='deletePicture'></div></div></div>";
              glob.imgWrap.append(html);
              glob.picturesVisitUpdate.push(e.target.result);
            }
            iterator++;
          }
          reader.readAsDataURL(f);
        }
      }
    });
  }
  
  mindate:Date = new Date();

  planifierRequest:any;
  plannedLoading:boolean=false;
  plan:any;
  Planifier(){
  this.plannedLoading=true;
    var formvalues = this.planifierForm.value;
    if(this.planifierForm.valid){
      this.planifierRequest = {
        planned_date :formvalues.planned_date
      }
      
      this.visitServiceservice.planifierRequest = this.planifierRequest;
      this.visitServiceservice.getPlanifier(this.visit_id);
      
      this.visitServiceservice.planifierSubject.subscribe(
      ( data: any ) => {  
        this.plannedLoading=false;
        if(data.code =="a3012ec200215ec0fb7a2b3744911348"){
          this.plan = {
            planned_date :data.planned_date,
            visit_status : data.visit_status
          };$("#successSave").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successSave").hide();
          }, 5000);
          // Recharger la liste des visites après avoir planifié avec succès
          this.Visit();
        }else{
          $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
        }
        $("#date"+this.visit_id).html(this.planifierRequest.planned_date);
        $("#status"+this.visit_id).html("<span style='display: inline-flex;'><span class='dot dot-planifie align-self-center mr-2'></span>Planifiée</span>");
      },)
    }
  }

  commercialid:any;
  fullname_commercial:any;
  visit_id:any;
  commercial_to_validate:any;
  customer_to_validate:any;
  getTeamid(client:any){
    this.commercialid = client.visit_commercial;
    this.commercial_to_validate = client.visit_affected_to;
    this.customer_to_validate = client.visit_customer;
    this.fullname_commercial = client.visit_customer;
    this.visit_id = client.visit;
    this.Time(this.commercialid);
    //this.Planifier(this.visit_id);
  } 
  slots:any[]=[];
  Time(id:any){
    this.loading_indicator = true;
    this.deplacementServiceservice.getTime(id);
    this.deplacementServiceservice.timeSubject.subscribe(
      ( data: any ) => {
        if(data.code =="3a0d48a1781451973acd36b7d6c725f4"){
          this.slots=data.slots;
        }this.loading_indicator = false;
      },
    )  
  }
  Deplacement(){
    this.deplacementServiceservice.getDeplacement();
    this.deplacementServiceservice.deplacementSubject.subscribe(
      ( data: any ) => {
        if(data.code =="6f1c1d62a91fb719d869d50deefae736"){          
          this.planned = data.indicators.planned;
          this.inProgress = data.indicators.inProgress;
          this.done = data.indicators.done;
          this.reported = data.indicators.reported;
          this.canceled = data.indicators.canceled;
        }this.loading_indicator = false;
      },
    )  
  }
  visit: any[] = [];
  canceledVisits: any[] = [];
  reportedVisits: any[] = [];
  terminatedVisits: any[] = [];
  startedVisits: any[] = [];
  originalVisits:any[] = [];
  plannedVisits:any[] = [];
  loading_visit:boolean=true;
  Visit(){
    this.loading_visit =true
    this.deplacementServiceservice.getVisit();
    this.deplacementServiceservice.visitSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f380b027226aa6025571a27993cbec61"){
          data.visits.forEach((visit:any) => {
            this.msSector.getSector(this.token, visit.visit_customer_sector).subscribe(
              (sectorLabel: any) => {
                visit.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });          
          this.canceledVisits = data.visits?.filter((visite: { visit_status: string; }) => visite.visit_status === 'Annulée');
          this.reportedVisits = data.visits?.filter((visite: { visit_status: string; }) => visite.visit_status === 'Reportée');
          this.terminatedVisits = data.visits?.filter((visite: { visit_status: string; }) => visite.visit_status === 'Terminée');
          this.startedVisits = data.visits?.filter((visite: { visit_status: string; }) => visite.visit_status === 'En cours');
          this.plannedVisits = data.visits?.filter((visite: { visit_status: string; }) => visite.visit_status === 'Planifiée');
          this.visit = data.visits;          
          this.visit = data.visits.filter((visite: { visit_status: string; }) => 
            visite.visit_status !== 'Annulée' && visite.visit_status !== 'Reportée' && visite.visit_status !== 'Terminée'
            && visite.visit_status !== 'En cours' && visite.visit_status !== 'Planifiée'
          );
          this.originalVisits= this.visit;
        }
        this.loading_visit = false;
        setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "pagingType": "full_numbers",
              "iDisplayLength": 25,
              order: [[2, 'asc']],
              columnDefs: [ { type: 'date', 'targets': [2] } ],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
      },
    )  
  }
  result_filtred:boolean=false;
  showFiltredVisits(type:any){
    if(!this.result_filtred){
      if(type=="canceled"){
        this.visit = this.canceledVisits;
        (<any>$('.hide_reported_filter')).css("display","none");
        (<any>$('.hide_terminated_filter')).css("display","none");
        (<any>$('.hide_started_filter')).css("display","none");
         (<any>$('.hide_planned_filter')).css("display","none");
        (<any>$('.hide_canceled_filter')).css("display","block");
        $('.canceledVisitsIndicator').addClass("selected_indicator");
      }else if (type=="reported"){
        this.visit = this.reportedVisits;
        (<any>$('.hide_canceled_filter')).css("display","none");
        (<any>$('.hide_terminated_filter')).css("display","none");
        (<any>$('.hide_started_filter')).css("display","none");
         (<any>$('.hide_planned_filter')).css("display","none");
        (<any>$('.hide_reported_filter')).css("display","block");
        $('.reportedVisitsIndicator').addClass("selected_indicator_reported");
      }else if (type=="terminated"){
        this.visit = this.terminatedVisits;
        (<any>$('.hide_canceled_filter')).css("display","none");
        (<any>$('.hide_reported_filter')).css("display","none");
        (<any>$('.hide_started_filter')).css("display","none");
         (<any>$('.hide_planned_filter')).css("display","none");
        (<any>$('.hide_terminated_filter')).css("display","block");
        $('.terminatedVisitsIndicator').addClass("selected_indicator_terminated");
      }else if (type=="started"){
        this.visit = this.startedVisits;
        (<any>$('.hide_canceled_filter')).css("display","none");
        (<any>$('.hide_reported_filter')).css("display","none");
        (<any>$('.hide_terminated_filter')).css("display","none");
        (<any>$('.hide_planned_filter')).css("display","none");
        (<any>$('.hide_started_filter')).css("display","block");
        $('.startedVisitsIndicator').addClass("selected_indicator_started");
      }else if (type=="planned"){
        this.visit = this.plannedVisits;
        (<any>$('.hide_canceled_filter')).css("display","none");
        (<any>$('.hide_reported_filter')).css("display","none");
        (<any>$('.hide_terminated_filter')).css("display","none");
        (<any>$('.hide_started_filter')).css("display","none");
        (<any>$('.hide_planned_filter')).css("display","block");
        $('.plannedVisitsIndicator').addClass("selected_indicator_planned");
      }
        if ((<any>$.fn).dataTable.isDataTable('#alter_pagination')) {
          (<any>$('#alter_pagination')).DataTable().clear();
          (<any>$('#alter_pagination')).DataTable().destroy();
        }
        // Forcer la détection des changements Angular
        this.cdr.detectChanges();
        setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "pagingType": "full_numbers",
              "iDisplayLength": 25,
              order: [[2, 'asc']],
              columnDefs: [ { type: 'date', 'targets': [2] } ],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        this.result_filtred = true;
        (<any>$('.icon_click_here')).css("display","none");
        
    }
  }
  hide_filter(type:any){
    this.visit = this.originalVisits;
    this.result_filtred = false;
    if(type=="canceled"){
      (<any>$('.hide_canceled_filter')).css("display","none");
      $('.canceledVisitsIndicator').removeClass("selected_indicator");
    }else if(type=="reported"){
      (<any>$('.hide_reported_filter')).css("display","none");
      $('.reportedVisitsIndicator').removeClass("selected_indicator_reported");
    }else if(type=="terminated"){
      (<any>$('.hide_terminated_filter')).css("display","none");
      $('.terminatedVisitsIndicator').removeClass("selected_indicator_terminated");
    }else if(type=="started"){
      (<any>$('.hide_started_filter')).css("display","none");
      $('.startedVisitsIndicator').removeClass("selected_indicator_started");
    }else if(type=="planned"){
      (<any>$('.hide_planned_filter')).css("display","none");
      $('.plannedVisitsIndicator').removeClass("selected_indicator_planned");
    }
    
      if ((<any>$.fn).dataTable.isDataTable('#alter_pagination')) {
        (<any>$('#alter_pagination')).DataTable().clear();
        (<any>$('#alter_pagination')).DataTable().destroy();
      }
      // Forcer la détection des changements Angular
      this.cdr.detectChanges();
      setTimeout(()=>{
          (<any>$("#alter_pagination")).DataTable( {
            "pagingType": "full_numbers",
            "iDisplayLength": 25,
            order: [[2, 'asc']],
            columnDefs: [ { type: 'date', 'targets': [2] } ],
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Chercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                    type: 'line',
                    width: '60',
                    height: '20',
                    lineColor: '#1a73e9',
                    fillColor: '#c2d5ff',
                    spotColor: 'transparent',
                    minSpotColor: 'transparent',
                    maxSpotColor: 'transparent',
                    highlightSpotColor: 'transparent',
                    highlightLineColor: 'transparent',
                });
            }
        });
      }, 200);
  }
  // showReportedVisits() {
  //   this.loading_visit = true;
  //   this.visit = this.reportedVisits;
  //   setTimeout(()=>{
  //       // const table = (<any>$('#alter_pagination')).DataTable();
  //       // table.clear().rows.add(this.visit).draw();
  //       if ((<any>$.fn).dataTable.isDataTable('#alter_pagination')) {
  //         (<any>$('#alter_pagination')).DataTable().destroy();
  //         (<any>$("#alter_pagination")).DataTable( {
  //         "pagingType": "full_numbers",
  //         "iDisplayLength": 25,
  //         order: [[2, 'asc']],
  //         columnDefs: [ { type: 'date', 'targets': [2] } ],
  //         "language": {
  //           "sProcessing": "Traitement en cours ...",
  //           "sLengthMenu": "Afficher _MENU_ lignes",
  //           "sZeroRecords": "Aucun résultat trouvé",
  //           "sEmptyTable": "Aucune donnée disponible",
  //           "sInfo": "",
  //           "sInfoEmpty": "",
  //           searchPlaceholder: "Saisir un mot clé",
  //           "sInfoFiltered": "",
  //           "sInfoPostFix": "",
  //           "sSearch": "Chercher:",
  //           "sUrl": "",
  //           "sInfoThousands": ",",
  //           "sLoadingRecords": "Chargement...",
  //           "oPaginate": {
  //             "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
  //           },
  //           "oAria": {
  //             "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
  //           }
  //         },
  //         drawCallback: function () {
  //           (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
  //                 type: 'line',
  //                 width: '60',
  //                 height: '20',
  //                 lineColor: '#1a73e9',
  //                 fillColor: '#c2d5ff',
  //                 spotColor: 'transparent',
  //                 minSpotColor: 'transparent',
  //                 maxSpotColor: 'transparent',
  //                 highlightSpotColor: 'transparent',
  //                 highlightLineColor: 'transparent',
  //             });
  //         }
  //     });
      
  //     }
  //     this.loading_visit = false;
  //   }, 200);
  // }
  detail:any;
  perso:any;
  actions:any;
  terminer_plan:boolean=true;
  Detail(id:any){
    this.terminer_plan=true;
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.detail= data.visit;
          this.perso= data.visit.actions;
          // this.CustumizedListactions(this.visit.visit_customer_uuid)
          // if(data.visit.actions != null && data.visit.actions != undefined)
          // this.actions= data.visit.actions.sort((a:any, b:any) => a.action_date - b.action_date);
          // this.actions= data.actions;
        }this.terminer_plan=false;
      },
    )  
  }
  sells:any[]=[];somme:any=0;noSells:boolean=false;
  addDetailToFinish(){
    if(this.terminatedVisitForm.valid){
      var finishVisitFormValues= this.terminatedVisitForm.value;
      this.sells.push(finishVisitFormValues);
    }else {
      this.terminatedVisitForm.markAllAsTouched();
    }
    this.terminatedVisitForm.reset()
  }
  removeDetailToFinish(element:any){
    var item1 = this.sells.find(i => i === element);
    var index = this.sells.indexOf(item1);
    if (index !== -1) {
      this.sells.splice(index, 1);
      this.somme =this.somme - (item1.price*item1.product_unit);
    }
  }
  cause:any;
  Idcall(client:any){
    this.cause = client.visit;
    this.Retrieve(this.cause);
  }
  retrieved:any;person:any;contact:any;
  Retrieve(id:any){
    this.terminer_plan=true;
    this.visitService.getRetrieve(id);
    this.visitService.retrieveSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.retrieved = data.visit;
          this.msSector.getSector(this.token,this.retrieved?.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.retrieved.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.person= data.visit.actions;
          this.sells= data.visit.contacted_persons;
        }this.terminer_plan=false;
      },
    )  
  }
  finalactions:any[]=[];
  modifyloading:boolean=false;
  modifyrepport(mode:any){
    this.modifyloading=true;
    $("#loading-"+this.retrieved.visit).css("display","inline-block");
    for(var act of this.person){
      var comment = document.getElementById(act.action) as HTMLTextAreaElement;
      var commentedaction = {
        "action": act.action,
        "action_description": act.action_desc,
        "action_comment":comment.value
      } 
      this.finalactions.push(commentedaction);
    }
    // if(this.terminatedVisitForm.valid){
    var terminateBody = {
      actions : this.finalactions,
      contacts : this.sells
    };
    this.dashboardServiceservice.bodyFinish = terminateBody;
    
    this.dashboardServiceservice.terminateVisit(this.cause,mode);
    this.dashboardServiceservice.startVisitSubject.subscribe(
    ( data: any ) => {
        if(data.code =="fe01fa6623c3648dcd4e15c482a2d602"){
          ;$("#successSave2").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successSave").hide();
          }, 5000);
          this.modifyloading=false;
          if(mode=="finish"){
            $("#edit-"+this.retrieved.visit).css("display","none");
            $("#action-"+this.retrieved.visit).html("- - -");
          }
          $("#loading-"+this.retrieved.visit).css("display","none");
        }else{
          $("#errors").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#errors").hide();
          }, 5000);
          this.modifyloading=false;
          $("#loading-"+this.retrieved.visit).css("display","none");
        }
      }
    ,)
  // }
  }   
  connectedCommercial:any="";
  today:any[]=[];allVisitsday:any []=[];
  TodayPlanning(){
    var globalvar = this;
    this.dashboardServiceservice.getToday();
    this.dashboardServiceservice.todaySubject.subscribe(
      ( data: any ) => {
        if(data.code =="e4b1ffed04086a59b097faa3afbf6197"){
          this.allVisitsday = data.visits;
          if(data.visits.length==0){
            setTimeout( function() {
              // create the notification
              var notification = new NotificationFx({
                  message : '<img src="assets/img/suivitim_img/calendar_white.gif" style="width: 50px;">'+
                  '<b>RAPPEL</b> : <br><p>Bonjour <b>'+globalvar.connectedCommercial+' </b><br> Aucune visite '+
                  'nˊest planifiée par vous pour aujourdˊhui ! <br>On vous invite à planifier de nouvelles visites <br><br>'+
                  '<img src="assets/img/suivitim_img/toright.gif" style="width: 25px;"><a href="planifier">  Planifier mes visites</a></p>',
                  layout : 'attached',
                  effect : 'bouncyflip',
                  type : 'notice', // notice, warning or error
                  onClose : function() {
                  }
              });
              // show the notification
              notification.show();
            }, 1200 );
          }
        }
      })
  }
  action:any[]=[];
  loading_actions:boolean=true;
  Actions(){
    var token:any = localStorage.getItem("token");
    if(token==null || token==undefined){
      token = sessionStorage.getItem("token");
    }
    
    let decodedJWT = JSON.parse(window.atob(token?.split('.')[1]));
    this.visitServiceservice.getActions(decodedJWT.userId);
    this.visitServiceservice.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
          this.action = data.actions;
          this.loading_actions = false;
        }
        setTimeout(()=>{
          // (<any>$.fn).dataTable.moment('DD/MM/YYYY HH:mm');
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "iDisplayLength": 25,
              // order: [[3, 'desc']],
              columnDefs: [ { type: 'date', 'targets': 3 } ],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 500);
      },
      )  
    }
  Pdf(id_visit:any){
    // this.pdfOrUpdateLoading = true;
    this.dashboardServiceservice.getPdf(id_visit);
    this.dashboardServiceservice.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
          const source = `data:application/pdf;base64,`+data.report;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.report_filename;
          link.click();
        }
      },)
  }

  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit, null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  }
  selectedCustomer:any=null;
  retrieveCustomerSubscription!:Subscription;
  retrieveCustomerLoder:boolean = false;
  retrieveCustomer(customer:any){
    this.retrieveCustomerLoder = true;
    this.selectedCustomer = null;
    this.retrieveCustomerSubscription=this.customersService.retrieveCustomer(customer).subscribe(
      (data:any) => {
        if (data.code == "91cb649c3775dae97f5a003ced0791b9"){
          this.selectedCustomer = data.customer;
        }
        this.retrieveCustomerLoder = false;
      },
      (error: any) => {
        console.log(error);
        this.retrieveCustomerLoder = false;
      }
    );
    this.getConversationAboutCustomer(customer);
  }

  loadingMessages:boolean=false;
  messages:any[]=[];
  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.loadingMessages=false;
          this.sending = false;
        },
        (error:any) => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  ngOnDestroy(){
    this.retrieveCustomerSubscription?.unsubscribe();
  }
}
